module.exports = __webpack_public_path__ + "static/media/banner_forest_density_data3.005bbe7b.jpg";